import React from 'react';
import TodosAll from './TodosAll';

class MyTodos extends React.Component {

  render() {
    return (
      <TodosAll
        myTodos
      />
    );
  }

}

export default MyTodos;



// WEBPACK FOOTER //
// ./src/components/todo/MyTodos.js